import React from "react";
import { FormConstants } from "utils/constants";
import { WintFormData, WizardProps } from "models/propTypes/wintFormPropsTypes";

function useWintWizard(form: WintFormData<any>): WizardProps {
  const [currentStep, setCurrentStep] = React.useState(0);
  const [currentStepExpanded, setCurrentStepExpanded] = React.useState(true);
  const [visitedSteps, setVisitedSteps] = React.useState(new Set([0]));
  const [numOfSteps, setNumberOfSteps] = React.useState<number>(0);

  const goToStep = (step: number) => {
    if (step === currentStep) {
      setCurrentStepExpanded((v) => !v);
    } else {
      setCurrentStepExpanded(true);
    }

    setVisitedSteps(new Set([...visitedSteps, currentStep]));
    setCurrentStep(step);
  };

  const setStepCount = (count: number) => {
    setNumberOfSteps(count);
  };

  const resetWizard = () => {
    setVisitedSteps(new Set([currentStep]));
  };

  return {
    currentStep,
    currentStepExpanded,
    visitedSteps: form.status === FormConstants.Submitted ? new Set([...Array(numOfSteps).keys()]) : visitedSteps,
    stepCount: numOfSteps,
    goToStep,
    setStepCount,
    resetWizard,
  };
}

export default useWintWizard;
